import ChallanBaseInput from "./ChallanBaseInput";
import { IconButton, InputAdornment, makeStyles, Search } from "../helper";

const useStyles = makeStyles((theme) => ({
  adornment: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: "white",
    height: 55,
    width: 50,
    borderRadius: theme.spacing(0, 4, 4, 0),
  },
}));

export default function ChallanSearchInput({ ...rest }) {
  const classes = useStyles();
  return (
    <ChallanBaseInput
      type={"text"}
      searchColor
      startAdornment={
        <div className={classes.adornment}>
          <InputAdornment position="start">
            <IconButton aria-label="search box" edge="end" sx={{ ml: "-4px" }}>
              <Search style={{ color: "rgba(226, 19, 110, 1)" }} />
            </IconButton>
          </InputAdornment>
        </div>
      }
      {...rest}
    />
  );
}
